import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, MenuItem, Stack, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useFormik } from 'formik';
import AddIcon from '@mui/icons-material/Add';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { addElectrician, editElectrician, getcategoryInEle, getElectrician, getElectricianById, getInstallerInEle, getproductInEle, getsubcategoryInEle } from '../../../redux/slice/electrician.slice';
import DownloadIcon from '@mui/icons-material/Download';
import { Image_URL } from '../../../utils/baseURL';
import DeleteIcon from '@mui/icons-material/Delete';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, icon, onClick, theme, error } = props;
    const icons = {
        1: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        2: <img src="/assets/images/icons/Customer.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        3: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active, error }} className={className} onClick={onClick}>
            {icons[String(icon)]}
        </ColorlibStepIconRoot>
    );
}
const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
    }),
    ...(ownerState.error && {
        border: '2px solid red',
    }),
}));

function AddElectrician() {
    const getuserId = localStorage.getItem("id");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const assignId = state?.assignId;
    const id = state?.electricianId;
    const liasoningId = state?.liasoningId;
    const electricians = useSelector(state => state.electrician.Electrician) || [];
    const AllElectrician = Array.isArray(electricians) ? electricians.find((a) => a?.assignId == assignId) : null;
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isMobile = useMediaQuery('(max-width:500px)');

    const theme = useTheme();

    console.log("state?.electricianId", state?.electricianId);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [activeStep, setActiveStep] = React.useState(0);
    const [stepsWithErrors, setStepsWithErrors] = React.useState([false, false, false, false, false]);
    const [touchedSteps, setTouchedSteps] = React.useState([false, false, false]);
    const assignInstaller = useSelector(state => state?.electrician?.assign)?.find((a) => a._id === assignId);
    const marketData = assignInstaller?.marketData[0];

    const validationSchemas =
        Yup.object({});

    const initialValues = {
        assignId: assignId,
        liasoningId: liasoningId,
        ElectricianDate: '',
        PanelInverterSerialNo: '',
        MultipleImages: [{
            electricianField: '',
            electricianImage: ''
        }],
        electricianDetails: [
            { electricianCatogory: '674fcda170f4d785f54f4353', electricianSubCatogory: '', electricianProductName: '', electricianQty: '' },
            { electricianCatogory: '674fcda170f4d785f54f4353', electricianSubCatogory: '', electricianProductName: '', electricianQty: '' },
            { electricianCatogory: '674fcda170f4d785f54f4353', electricianSubCatogory: '', electricianProductName: '', electricianQty: '' },
            { electricianCatogory: '674fcda170f4d785f54f4353', electricianSubCatogory: '', electricianProductName: '', electricianQty: '' },
        ],
        SystemSize: marketData?.SystemSizeKw,
        RateKw: '',
        TotalAmount: '',
    };

    const [electricianFields, setelectricianFields] = React.useState(initialValues.MultipleImages || []);
    const [changeimageMultiple, setchangeimageMultiple] = React.useState([{ changed: false, index: 0 }]);


    const handleAddDetail = () => {
        setelectricianFields([...electricianFields, {
            electricianField: '',
            electricianImage: ''
        }])
        setchangeimageMultiple(prev => [...prev, { changed: false, index: electricianFields.length }]);
        setFieldValue(`electricianImage.[${electricianFields.length}]`, '');
    }

    useEffect(() => {
        dispatch(getcategoryInEle())
        dispatch(getsubcategoryInEle())
        dispatch(getproductInEle())
        dispatch(getInstallerInEle())
    }, [dispatch])

    const isSmallScreen = useMediaQuery("(max-width:425px)");
    const steps = ['Site Photo', 'Use of Material', 'Payment'];

    const [openView, setOpenView] = React.useState(false);
    const [viewImage, setViewImage] = React.useState(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const downloadRef = React.useRef(null);

    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleDownload = async () => {
        if (viewImage) {
            try {
                let response;
                let downloadUrl;
                let fileExtension = '';
                if (viewImage instanceof Blob) {
                    downloadUrl = URL.createObjectURL(viewImage);
                    if (viewImage.type === 'application/pdf') {
                        fileExtension = 'pdf';
                    }
                } else {
                    if (id) {
                        const proxyUrl = `/api/proxy-image?url=${encodeURIComponent(viewImage)}`;
                        response = await fetch(proxyUrl);
                    } else {
                        response = await fetch(viewImage);
                    }

                    if (response.ok) {
                        const blob = await response.blob();
                        downloadUrl = URL.createObjectURL(blob);
                        if (blob.type === 'application/pdf') {
                            fileExtension = 'pdf';
                        }
                    } else {
                        console.error('Failed to download image');
                        return;
                    }
                }

                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `dealer${fileExtension}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(downloadUrl);
            } catch (error) {
                console.error('Error in download process:', error);
            }
        } else {
            console.error('No image to download');
        }
    };



    const handleSubmit = async (values) => {
        

        const errors = {};
        if (!values.ElectricianDate) {
            errors.ElectricianDate = 'Electrician Date is required';
        }
        if (!values.MultipleImages || values.MultipleImages.length === 0) {
            errors.MultipleImages = 'At least one image is required';
        } else {
            values.MultipleImages.forEach((image, index) => {
                if (!image.electricianField) {
                    errors[`MultipleImages[${index}].electricianField`] = 'Panel & Inverter Serial No is required';
                }
                if (!image.electricianImage) {
                    errors[`MultipleImages[${index}].electricianImage`] = 'Image is required';
                }
            });
        }
        values.electricianDetails.forEach((detail, index) => {
            if (!detail.electricianCatogory) {
                errors[`electricianDetails[${index}].electricianCatogory`] = 'Category is required';
            }
            if (!detail.electricianSubCatogory) {
                errors[`electricianDetails[${index}].electricianSubCatogory`] = 'Subcategory is required';
            }
            if (!detail.electricianProductName) {
                errors[`electricianDetails[${index}].electricianProductName`] = 'Product Name is required';
            }
            if (!detail.electricianQty) {
                errors[`electricianDetails[${index}].electricianQty`] = 'Quantity is required';
            }
        });

        let res;
        const submissionValues = {
            ...values,
            assignId: assignId,
            userId: getuserId,
            MultipleImages: values.MultipleImages.map((detail, index) => ({
                ...detail,
                electricianImage: detail.electricianImage instanceof File ? detail.electricianImage.name : detail.electricianImage
            })) || null,
            electricianDetails: values.electricianDetails.map(detail => ({
                ...detail,
                electricianCatogory: detail.electricianCatogory || "674fcda170f4d785f54f4353",
                electricianSubCatogory: detail.electricianSubCatogory || "",
                electricianProductName: detail.electricianProductName || "",
                electricianQty: detail.electricianQty || "",
            })) || null,
            SystemSize: marketData?.SystemSizeKw,
            TotalAmount: (marketData?.SystemSizeKw * values.RateKw).toFixed(2) || '',
        };

        if (values.RateKw > 0) {
            setIsSubmitting(true);
            
            if (id) {
                res = await dispatch(editElectrician({ _id: id, ...submissionValues }));
            } else {
                res = await dispatch(addElectrician(submissionValues));
            }

            console.log("ressssssssssss", res);

            if (res?.type === "electrician/edit/fulfilled" || res.type === "electrician/add/fulfilled") {
                await dispatch(getInstallerInEle());
                setActiveStep(0);
                navigate('/admin/electrician');
            }
        } else {
            alert("Rate/KW must be greater than 0")
        }







    };

    const { handleBlur, handleChange, resetForm, values, touched, errors, setFieldValue, setValues, validateForm, setFieldError, setFieldTouched } = useFormik({
        initialValues: { ...initialValues, MultipleImages: electricianFields },
        validationSchema: validationSchemas,
        onSubmit: handleSubmit,
    });

    const hasStep1Data = () => {
        return values.electricianDetails?.some(detail => (
            detail.electricianSubCatogory ||
            detail.electricianProductName ||
            detail.electricianQty
        ));
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => {
        setActiveStep(step);
    };

    React.useEffect(() => {
        if (touchedSteps.some(touched => touched)) {
            validateForm().then((formErrors) => {
                const newStepsWithErrors = [false, false, false];

                Object.keys(formErrors).forEach((errorKey) => {
                    steps.forEach((_, stepIndex) => {
                        if (errorBelongsToStep(errorKey, stepIndex)) {
                            newStepsWithErrors[stepIndex] = true;
                        }
                    });
                });

                setStepsWithErrors(newStepsWithErrors);
            });
        }
    }, [values, touchedSteps]);


    const errorBelongsToStep = (errorKey, stepIndex) => {
        if (stepIndex === 0) {
            return ['ElectricianDate', 'PanelInverterSerialNo'].includes(errorKey);
        }
        else if (stepIndex === 1) {
            return ['ElectricianDate', 'PanelInverterSerialNo'].includes(errorKey);
        }
        else if (stepIndex === 2) {
            return ['ElectricianDate', 'PanelInverterSerialNo'].includes(errorKey);
        }
    };

    useEffect(() => {
        if (assignId) {
            dispatch(getElectrician(getuserId));
        }
    }, [assignId, id]);


    React.useEffect(() => {
        if (id && AllElectrician) {
            dispatch(getElectricianById(id)).then((response) => {
                if (response.payload) {
                    const ElectricianData = response.payload;
                    setValues({
                        ...ElectricianData,
                        electricianImage: Array.isArray(ElectricianData.electricianImage) ? ElectricianData.electricianImage[0] : ElectricianData.electricianImage,
                        electricianDetails: ElectricianData.electricianDetails.length > 0 ? ElectricianData.electricianDetails : initialValues.electricianDetails,
                    });
                    setelectricianFields([...ElectricianData.MultipleImages]);
                    setelectrician([...ElectricianData.electricianDetails]);
                    const initialChangeImageMultiple = ElectricianData.MultipleImages.map((detail, index) => ({
                        changed: false,
                        index: index,
                    }));
                    setchangeimageMultiple(initialChangeImageMultiple);

                    const isStep1Complete = ElectricianData.MultipleImages.length > 0;
                    const isStep2Complete = ElectricianData.electricianDetails.some(detail =>
                        detail.electricianSubCatogory &&
                        detail.electricianProductName &&
                        detail.electricianQty
                    );

                    if (isStep1Complete && isStep2Complete) {
                        setActiveStep(2);
                    } else if (isStep1Complete) {
                        setActiveStep(1);
                    } else {
                        setActiveStep(0);
                    }
                } else {
                    console.error("Unexpected response structure:", response);
                }
            }).catch(error => {
                console.error("Error fetching data:", error);
            });
        }
    }, [id, AllElectrician]);


    // const handleView = (imageType) => {
    //     let imageUrl;
    //     const baseUrl = imgUrl;

    //     if (imageType.startsWith('MultipleImages')) {
    //         const match = imageType.match(/\[(\d+)\]/);
    //         if (match) {
    //             const index = parseInt(match[1], 10);
    //             if (values.electricianImage && values.electricianImage[index]) {
    //                 imageUrl = values.electricianImage[index] instanceof File
    //                     ? URL.createObjectURL(values.electricianImage[index])
    //                     : `${baseUrl}/${values.electricianImage[index]}`;
    //             } else if (values.MultipleImages && values.MultipleImages[index] && values.MultipleImages[index].electricianImage) {
    //                 imageUrl = `${baseUrl}/${values.MultipleImages[index].electricianImage}`;
    //             }
    //         }
    //     }

    //     if (imageUrl) {
    //         setViewImage(imageUrl);
    //         setOpenView(true);
    //     } else {
    //         console.error("No image found for the selected type:", imageType);
    //     }
    // }

    const handleView = (imageType) => {
        let imageUrl;
        const baseUrl = imgUrl;


        if (imageType.startsWith('MultipleImages')) {
            const match = imageType.match(/MultipleImages\[(\d+)\](?:\.electricianImage)?$/);
            if (match) {
                const index = parseInt(match[1], 10);
                if (values.electricianImage && values.electricianImage[index]) {
                    imageUrl = values.electricianImage[index] instanceof File
                        ? URL.createObjectURL(values.electricianImage[index])
                        : `${baseUrl}/${values.electricianImage[index]}`;
                } else if (values.MultipleImages && values.MultipleImages[index] && values.MultipleImages[index].electricianImage) {
                    imageUrl = `${baseUrl}/${values.MultipleImages[index].electricianImage}`;
                } else if (values.MultipleImages && values.MultipleImages[index] && values.MultipleImages[index].UploadPaymentSlip) {
                    imageUrl = `${baseUrl}/${values.MultipleImages[index].UploadPaymentSlip}`;
                }
            }
        } else if (imageType.startsWith('MultipleDetails')) {
            const match = imageType.match(/MultipleDetails\[(\d+)\](?:\.electricianImage)?$/);
            if (match) {
                const index = parseInt(match[1], 10);
                if (values.electricianImage && values.electricianImage[index]) {
                    imageUrl = values.electricianImage[index] instanceof File
                        ? URL.createObjectURL(values.electricianImage[index])
                        : `${baseUrl}/${values.electricianImage[index]}`;
                } else if (values.MultipleImages && values.MultipleImages[index] && values.MultipleImages[index].electricianImage) {
                    imageUrl = `${baseUrl}/${values.MultipleImages[index].electricianImage}`;
                }
            }
        }

        if (imageUrl) {
            setViewImage(imageUrl);
            setOpenView(true);
        } else {
            console.error("No image found for the selected type:", imageType);
        }
    };

    const imgUrl = Image_URL;

    const [electrician, setelectrician] = useState([
        { electricianCatogory: '', electricianSubCatogory: '', electricianProductName: '', electricianQty: '' },
        { electricianCatogory: '', electricianSubCatogory: '', electricianProductName: '', electricianQty: '' },
        { electricianCatogory: '', electricianSubCatogory: '', electricianProductName: '', electricianQty: '' },
        { electricianCatogory: '', electricianSubCatogory: '', electricianProductName: '', electricianQty: '' },
    ]);

    const handleAddRow = () => {
        setelectrician([...electrician, {
            electricianCatogory: '',
            electricianSubCatogory: '',
            electricianProductName: '',
            electricianQty: '',
        }]);
    };

    const [filteredProducts, setFilteredProducts] = useState([]);
    const categories = useSelector(state => state.electrician.category);
    const subcategories = useSelector(state => state.electrician.subCategory);
    const productData = useSelector(state => state.electrician.products)

    const filteredSubcategories = subcategories?.filter(subcategory =>
        subcategory?.categoryData[0]?._id === '674fcda170f4d785f54f4353'
    );

    const getFilteredProducts = (subcategoryId) => {
        return productData?.filter(product => product?.subCategoryData[0]?._id === subcategoryId);
    };

    const handleCategoryChange = (index, value) => {
        setFieldValue(`electricianDetails[${index}].electricianCatogory`, value);
        setFieldValue(`electricianDetails[${index}].electricianSubCatogory`, "");
        setFieldValue(`electricianDetails[${index}].electricianProductName`, "");
        setFieldValue(`electricianDetails[${index}].electricianQty`, "");
        const productsForCategory = productData?.filter(product => product.mainCategory._id === value);
        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForCategory || [];
            return newFilteredProducts;
        });
    };

    const handleSubCategoryChange = (index, value) => {
        setFieldValue(`electricianDetails[${index}].electricianSubCatogory`, value);
        const productsForSubcategory = productData?.filter(product => product.subCategory._id === value);
        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForSubcategory || [];
            return newFilteredProducts;
        });
    };

    const handleProductChange = (index, value) => {
        setFieldValue(`electricianDetails[${index}].electricianProductName`, value);
        const product = productData?.find(product => product._id === value);
    }

    const handleElectricianAdd = (index) => {
        const oldElectricianDetails = [...values.electricianDetails];
        const newElectrician = {
            electricianCatogory: '',
            electricianSubCatogory: '',
            electricianProductName: '',
            electricianQty: '',
        };
        oldElectricianDetails.splice(index + 1, 0, newElectrician);
        setelectrician(oldElectricianDetails);
        setFieldValue('electricianDetails', oldElectricianDetails);
        setelectrician(oldElectricianDetails);
    }

    const handleDeleteElectrician = (index) => {
        const updatedElectricianDetails = electrician.filter((_, i) => i !== index);
        setelectrician(updatedElectricianDetails);
        setFieldValue('electricianDetails', updatedElectricianDetails);
    }
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const handleOpenConfirmDialog = (index) => {
        setDeleteIndex(index);
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = () => {
        handleDeleteElectrician(deleteIndex);
        setOpenConfirmDialog(false);
    };


    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
            {id ? (
                <Header
                    title="UPDATE ELECTRICIAN"
                    subtitle="Update Your Electrician Detail"
                />
            ) : (
                <Header
                    title="ADD ELECTRICIAN"
                    subtitle="Manage Your Electrician Detail"
                />
            )}
            <form onSubmit={handleSubmit} >
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    {isSmallScreen ? (
                        <>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.slice(0, 3).map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={(props) => (
                                            <ColorlibStepIcon
                                                {...props}
                                                theme={theme}
                                                icon={index + 1}
                                                onClick={() => handleStep(index)}
                                                error={touchedSteps[index] && stepsWithErrors[index]}
                                                style={{
                                                    cursor: (index === 0 && hasStep1Data()) ? 'not-allowed' : 'pointer',
                                                    opacity: (index === 0 && hasStep1Data()) ? 0.5 : 1
                                                }}
                                            />
                                        )}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.slice(3).map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={(props) => (
                                            <ColorlibStepIcon
                                                {...props}
                                                theme={theme}
                                                icon={index + 4}
                                                onClick={() => handleStep(index + 3)}
                                                error={touchedSteps[index + 3] && stepsWithErrors[index + 3]}
                                                style={{
                                                    cursor: (index === 0 && hasStep1Data()) ? 'not-allowed' : 'pointer',
                                                    opacity: (index === 0 && hasStep1Data()) ? 0.5 : 1
                                                }}
                                            />
                                        )}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </>
                    ) : (
                        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                            {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={(props) => (
                                        <ColorlibStepIcon
                                            {...props}
                                            theme={theme}
                                            icon={index + 1}
                                            onClick={() => handleStep(index)}
                                            error={touchedSteps[index] && stepsWithErrors[index]}
                                            style={{
                                                cursor: (index === 0 && hasStep1Data()) ? 'not-allowed' : 'pointer',
                                                opacity: (index === 0 && hasStep1Data()) ? 0.5 : 1
                                            }}
                                        />
                                    )}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    )}
                    {activeStep === 0 && (
                        <>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="date"
                                        label="Date:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.ElectricianDate}
                                        name="ElectricianDate"
                                        error={!!touched.ElectricianDate && !!errors.ElectricianDate}
                                        helperText={touched.ElectricianDate && errors.ElectricianDate}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>

                            </Box>

                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                {electricianFields.length === 0 && handleAddDetail()}
                                {electricianFields && electricianFields.length > 0 && electricianFields.map((field, index) => (
                                    <React.Fragment key={index}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <TextField
                                                margin="dense"
                                                name={`MultipleImages[${index}].electricianField`}
                                                label={index === 0 ? "Panel & Inverter Serial No" : `Input Field ${index}`}
                                                type="text"
                                                fullWidth
                                                variant="filled"
                                                onChange={(e) => {
                                                    const newField = { ...electricianFields[index], electricianField: e.target.value };
                                                    const newFields = [...electricianFields.slice(0, index), newField, ...electricianFields.slice(index + 1)];
                                                    setelectricianFields(newFields);
                                                    setFieldValue(`MultipleImages[${index}].electricianField`, e.target.value);
                                                }}
                                                value={values.MultipleImages?.[index]?.electricianField}
                                                error={touched.MultipleImages?.[index]?.electricianField && Boolean(errors.MultipleImages?.[index]?.electricianField)}
                                                helperText={touched.MultipleImages?.[index]?.electricianField && errors.MultipleImages?.[index]?.electricianField}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                            <Button variant="contained" component="label">
                                                Upload
                                                <input
                                                    type="file"
                                                    hidden
                                                    name={`MultipleImages[${index}].electricianImage`}
                                                    onChange={e => {
                                                        const files = Array.from(e.target.files);
                                                        setFieldValue(`electricianImage.[${index}]`, files[0]);
                                                        setchangeimageMultiple(prev => prev.map((item, idx) =>
                                                            idx == index ? { ...item, changed: true } : item
                                                        ));
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                            </Button>
                                            {changeimageMultiple[index]?.changed ? (
                                                values.electricianImage?.[index] && values.electricianImage[index] instanceof File ? (
                                                    values.electricianImage[index].name.toLowerCase().endsWith('.pdf') ? (
                                                        <iframe
                                                            src={URL.createObjectURL(values.electricianImage[index])}
                                                            style={{ width: '50px', height: '50px', border: 'none' }}
                                                            title="PDF Preview"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={values.electricianImage[index] instanceof File
                                                                ? URL.createObjectURL(values.electricianImage[index])
                                                                : `${imgUrl}/${values.electricianImage[index]}`}
                                                            alt="avatar"
                                                            width="50"
                                                            height="50"
                                                            style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                        />
                                                    )
                                                ) : (
                                                    values.MultipleImages?.[index]?.electricianImage && (
                                                        <img
                                                            src={`${imgUrl}/${values.MultipleImages[index].electricianImage}`}
                                                            alt="avatar"
                                                            width="50"
                                                            height="50"
                                                            style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                        />
                                                    )
                                                )
                                            ) : (
                                                values.MultipleImages?.[index]?.electricianImage && (
                                                    typeof values.MultipleImages?.[index]?.electricianImage === 'string' && values.MultipleImages?.[index]?.electricianImage.toLowerCase().endsWith('.pdf') ? (
                                                        <iframe
                                                            src={`${imgUrl}/${values.MultipleImages?.[index]?.electricianImage}`}
                                                            style={{ width: '50px', height: '50px', border: 'none' }}
                                                            title="PDF Preview"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={`${imgUrl}/${values.MultipleImages?.[index]?.electricianImage}`}
                                                            alt="avatar"
                                                            width="50"
                                                            height="50"
                                                            style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                        />
                                                    )
                                                )
                                            )
                                            }
                                            <IconButton aria-label="edit" onClick={() => handleView(`MultipleImages[${index}].electricianImage`)}>
                                                <RemoveRedEyeIcon />
                                            </IconButton>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </Box>

                            <Box display="flex" justifyContent="flex-end" m={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddDetail}
                                >
                                    Add Detail
                                </Button>
                            </Box>

                        </>
                    )}

                    {activeStep === 1 && (
                        <Box sx={{ overflowX: "auto", width: "100%" }}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: "70px", fontSize: "14px" }} > Sr No</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }} >Category</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }} >Sub Category</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }} >Product Name</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }}>Quantity</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {electrician.map((person, index) => (
                                            <TableRow
                                                key={index}>
                                                <TableCell sx={{ width: 50 }}>
                                                    {index + 1}
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "200px",
                                                                sm: "220px",
                                                                md: "280px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`electricianDetails.${index}.electricianCatogory`}
                                                        onChange={e => handleCategoryChange(index, e.target.value)}
                                                        value={values.electricianDetails?.[index]?.electricianCatogory || '674fcda170f4d785f54f4353'}
                                                        error={!!touched.electricianDetails?.[index]?.electricianCatogory && !!errors.electricianDetails?.[index]?.electricianCatogory}
                                                        helperText={touched.electricianDetails?.[index]?.electricianCatogory && errors.electricianDetails?.[index]?.electricianCatogory}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                        disabled
                                                    >
                                                        {categories?.map((category) => (
                                                            <MenuItem key={category._id} value={category._id} >
                                                                {category.categoryName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "200px",
                                                                sm: "220px",
                                                                md: "280px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`electricianDetails.${index}.electricianSubCatogory`}
                                                        onChange={e => setFieldValue(`electricianDetails.${index}.electricianSubCatogory`, e.target.value)}
                                                        value={values.electricianDetails?.[index]?.electricianSubCatogory || ''}
                                                        error={!!touched.electricianDetails?.[index]?.electricianSubCatogory && !!errors.electricianDetails?.[index]?.electricianSubCatogory}
                                                        helperText={touched.electricianDetails?.[index]?.electricianSubCatogory && errors.electricianDetails?.[index]?.electricianSubCatogory}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    >
                                                        {filteredSubcategories.map((subcategory) => (
                                                            <MenuItem key={subcategory._id} value={subcategory._id}>
                                                                {subcategory.subCategoryName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "200px",
                                                                sm: "220px",
                                                                md: "280px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`electricianDetails.${index}.electricianProductName`}
                                                        onChange={e => handleProductChange(index, e.target.value)}
                                                        value={values.electricianDetails?.[index]?.electricianProductName || ''}
                                                        error={!!touched.electricianDetails?.[index]?.electricianProductName && !!errors.electricianDetails?.[index]?.electricianProductName}
                                                        helperText={touched.electricianDetails?.[index]?.electricianProductName && errors.electricianDetails?.[index]?.electricianProductName}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    >
                                                        {getFilteredProducts(values.electricianDetails?.[index]?.electricianSubCatogory).map(product => (
                                                            <MenuItem key={product._id} value={product._id}>
                                                                {product.productName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        sx={{
                                                            width: {
                                                                xs: "80px",
                                                                sm: "80px",
                                                                md: "80px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={e => setFieldValue(`electricianDetails[${index}].electricianQty`, e.target.value)}
                                                        value={values.electricianDetails?.[index]?.electricianQty || ''}
                                                        name={`electricianDetails.${index}.electricianQty`}
                                                        error={!!touched.electricianDetails?.[index]?.electricianQty && !!errors.electricianDetails?.[index]?.electricianQty}
                                                        helperText={touched.electricianDetails?.[index]?.electricianQty && errors.electricianDetails?.[index]?.electricianQty}

                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Stack spacing={2} direction="row">
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            onClick={() => handleElectricianAdd(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <AddIcon sx={{ fontSize: "16px" }} />
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="error"
                                                            onClick={() => handleOpenConfirmDialog(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <DeleteIcon sx={{ fontSize: "16px" }} />
                                                        </Button>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    )}

                    {activeStep === 2 && (
                        <>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="System Size:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={marketData?.SystemSizeKw}
                                        name="SystemSize"
                                        error={!!touched.SystemSize && !!errors.SystemSize}
                                        helperText={touched.SystemSize && errors.SystemSize}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Rate/KW:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.RateKw}
                                        name="RateKw"
                                        error={!!touched.RateKw && !!errors.RateKw}
                                        helperText={touched.RateKw && errors.RateKw}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Total Amount:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={(marketData?.SystemSizeKw * values.RateKw).toFixed(2)}
                                        name="TotalAmount"
                                        error={!!touched.TotalAmount && !!errors.TotalAmount}
                                        helperText={touched.TotalAmount && errors.TotalAmount}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Box>
                        </>
                    )}

                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                            >
                                Back
                            </Button>
                            {activeStep < 2 && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        setActiveStep((prev) => prev + 1);
                                    }}
                                >
                                    Next
                                </Button>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                onClick={() => handleSubmit(values)}
                                disabled={isSubmitting}

                            >
                                {id ? 'Update' : 'Save'}
                            </Button>
                        </Stack>
                    </FormControl>
                    <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                            Are you sure you want to delete this item?
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseConfirmDialog} sx={{ color: theme.palette.text.primary }}>
                                Cancel
                            </Button>
                            <Button onClick={handleConfirmDelete} color="error">
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>



                    <Dialog
                        fullScreen={fullScreen}
                        open={openView}
                        onClose={handleCloseView}
                        aria-labelledby="responsive-dialog-title"
                        maxWidth={"sm"}
                        fullWidth
                    >
                        <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'right' }}>
                            <Button
                                onClick={handleDownload}
                                style={{ color: theme.palette.text.primary }}
                                startIcon={<DownloadIcon />}
                                disabled={!viewImage}
                            >
                                Download
                            </Button>
                        </DialogTitle>
                        <DialogContent style={{ backgroundColor: theme.palette.background.purple, display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                            {viewImage ? (
                                viewImage instanceof File ? (
                                    viewImage.name.toLowerCase().endsWith('.pdf') ? (
                                        <iframe
                                            src={URL.createObjectURL(viewImage)}
                                            style={{ width: '100%', height: '80vh', border: 'none' }}
                                            title="PDF Preview"
                                        />
                                    ) : (
                                        <img
                                            src={URL.createObjectURL(viewImage)}
                                            alt="Uploaded Image"
                                            style={{ width: '100%', height: '80vh', objectFit: 'contain' }}
                                            ref={downloadRef}
                                        />
                                    )
                                ) : (
                                    typeof viewImage === 'string' && viewImage.toLowerCase().endsWith('.pdf') ? (
                                        <iframe
                                            src={viewImage}
                                            style={{ width: '100%', height: '80vh', border: 'none' }}
                                            title="PDF Preview"
                                        />
                                    ) : (
                                        <img
                                            src={viewImage}
                                            alt="Uploaded Image"
                                            style={{ width: '100%', height: '80vh', objectFit: 'contain' }}
                                            ref={downloadRef}
                                        />
                                    )
                                )
                            ) : (
                                <p>No image to display</p>
                            )}
                        </DialogContent>
                        <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                            <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Stack>
            </form>
        </Box>
    )
}

export default AddElectrician
